import React, { useContext } from 'react';
import { translations } from 'src/constants/translations';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import {
  UnitsDataContext,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/context/UnitsDataProvider';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { MarketplaceButton } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceButton';
import AddIcon from '@mui/icons-material/Add';
import {
  UnitsCardTextBoxEntity,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/UnitsCardTextBox/components/UnitsCardTextBoxEntity';
import { RandomInteger } from 'src/helpers/randomInteger';
import { ReactSortable, Sortable, Store } from 'react-sortablejs';
import { useStyles } from '../Common/styles';

export const UnitsCardTextBox: React.FC = () => {
  const styles = useStyles();
  const context = useContext(UnitsDataContext);
  const mainStyles = mainUseStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(!!context?.state.unitsOrder.isActive);

  const rocketChange = (state: boolean) => {
    if (context?.state.unitsOrder) {
      context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, firstHeader: { ...current.unitsCard.firstHeader, textBox: { ...current.unitsCard.firstHeader.textBox, isActive: state } } } }));
      setRocketState(state);
    }
  };

  const moveToTrash = (index: number) => {
    if (context) {
      context.updateState((current) => ({
        ...current,
        unitsCard: {
          ...current.unitsCard,
          firstHeader: {
            ...current.unitsCard.firstHeader,
            textBox: {
              ...current.unitsCard.firstHeader.textBox,
              elements: current.unitsCard.firstHeader.textBox.elements.filter((_, itemIndex) => itemIndex !== index),
            },
          },
        },
      }));
    }
  };

  const addBox = () => {
    if (context) {
      const element = {
        '@id': RandomInteger().toString(),
        iconFileUri: null,
        prefix: null,
        suffix: null,
        property: {
          diType: 'PlacementProperty' as const,
          oldSystemName: null,
          systemName: '',
          translates: null,
        },
        styles: {
          fontWeight: 'normal',
          textDecoration: 'none',
          color: '',
          backgroundColor: '',
          borderColor: '',
        },
      };
      context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, firstHeader: { ...current.unitsCard.firstHeader, textBox: { ...current.unitsCard.firstHeader.textBox, elements: [...current.unitsCard.firstHeader.textBox.elements, element] } } } }));
    }
  };

  return (
    <>
      <GroupWrapper
        name={translations.unitsCardTextBox}
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => {
              setCollapseState(state);
            }}
          />
      )}
      >
        {collapseState === GroupWrapperCollapseState.OPEN && (
        <div className={styles.wrapper}>
          <div className={styles.text}>
            {translations.AddAnother1stHeaderElement}
          </div>
          <div>
            <MarketplaceButton
              startIcon={<AddIcon />}
              label={translations.textInBox}
              onClick={() => addBox()}
            />
          </div>
        </div>
        ) }
      </GroupWrapper>
      {context && (
        <ReactSortable<any>
          className={mainStyles.iteratorWrapper}
          animation={150}
          handle=".drag-handle"
          list={context.state.unitsCard.firstHeader.textBox.elements.map((el) => ({ ...el, chosen: false }))}
          setList={(newList, sortable: Sortable | null, store: Store) => {
            if (store && store.dragging && store.dragging.props
              && JSON.stringify(store.dragging.props.list) !== JSON.stringify(newList)) {
              context.updateState((current) => ({ ...current, unitsCard: { ...current.unitsCard, firstHeader: { ...current.unitsCard.firstHeader, textBox: { ...current.unitsCard.firstHeader.textBox, elements: newList } } } }));
            }
          }}
        >
          {collapseState === GroupWrapperCollapseState.OPEN && context.state.unitsCard.firstHeader.textBox.elements.map((item, index) => (
            <React.Fragment key={item['@id']}>
              <UnitsCardTextBoxEntity
                entity={item}
                onChange={(entity) => context.updateState((current) => ({
                  ...current,
                  unitsCard: {
                    ...current.unitsCard,
                    firstHeader: {
                      ...current.unitsCard.firstHeader,
                      textBox: {
                        ...current.unitsCard.firstHeader.textBox,
                        elements: current.unitsCard.firstHeader.textBox.elements.map((element, itemIndex) => (itemIndex === index ? entity : element)),
                      },
                    },
                  },
                }))}
                lang={context.state.marketplace.language}
                propertyOptions={context.state.placementPropertyOptions}
                moveToTrash={() => moveToTrash(index)}
              />
            </React.Fragment>
          ))}
        </ReactSortable>
      )}
    </>
  );
};
